import React from 'react';

interface GameStatsProps {
    score: number;
    level: number;
    lives: number;
}

const GameStats: React.FC<GameStatsProps> = ({ score, level, lives }) => {
    return (
        <div style={{
            position: 'absolute',
            top: '200px',
            right: '140px',
            display: 'flex',
            flexDirection: 'column',
            gap: '15px',
            padding: '15px',
            // background: 'linear-gradient(135deg, rgba(25,25,112,0.9) 0%, rgba(65,105,225,0.8) 50%, rgba(0,191,255,0.7) 100%)',
            background: 'linear-gradient(135deg,rgba(14, 82, 104, 0.46) 0%,rgba(14, 82, 104, 0.46) 50%,rgba(0, 191, 255, 0.46) 100%)',

            borderRadius: '10px',
            // border: '2px solid #4169E1',
            boxShadow: '0 8px 25px rgba(0,0,0,0.5), 0 0 15px rgba(65,105,225,0.3)',
            animation: 'statsGlow 2s ease-in-out infinite alternate',
            minWidth: '180px',
            textAlign: 'left'
        }}>
            <div style={{
                color: '#00BFFF',
                fontWeight: 'bold',
                marginBottom: '10px',
                textAlign: 'center',
                fontSize: '16px',
                textShadow: '1px 1px 3px rgba(0,0,0,0.8)'
            }}>
                🏆 SPACE STATS
            </div>

            <div style={{
                color: '#F0F8FF',
                fontSize: '15px',
                lineHeight: '1.4'
            }}>
                <div style={{
                    marginBottom: '8px',
                    padding: '5px',
                    background: 'rgba(0,191,255,0.1)',
                    borderRadius: '5px',
                    border: '1px solid rgba(0,191,255,0.3)'
                }}>
                    ⭐ Score: <span style={{
                        color: '#00BFFF',
                        textShadow: '0 0 10px rgba(0,191,255,0.8)',
                        animation: 'scoreGlow 1.5s ease-in-out infinite alternate'
                    }}>
                        {score.toLocaleString()}
                    </span>
                </div>

                <div style={{
                    marginBottom: '8px',
                    padding: '5px',
                    background: 'rgba(65,105,225,0.1)',
                    borderRadius: '5px',
                    border: '1px solid rgba(65,105,225,0.3)'
                }}>
                    🚀 Level: <span style={{
                        color: '#4169E1',
                        textShadow: '0 0 10px rgba(65,105,225,0.8)',
                        animation: 'levelGlow 1.5s ease-in-out infinite alternate'
                    }}>
                        {level}
                    </span>
                </div>

                <div style={{
                    marginBottom: '8px',
                    padding: '5px',
                    background: 'rgba(147,112,219,0.1)',
                    borderRadius: '5px',
                    border: '1px solid rgba(147,112,219,0.3)'
                }}>
                    🌟 Lives: <span style={{

                        color: 'rgba(229, 11, 109, 0.89)',
                        textShadow: '0 0 10px rgba(219, 112, 160, 0.8)',
                        animation: 'livesGlow 1.5s ease-in-out infinite alternate'
                    }}>
                        {'♥'.repeat(lives)}
                    </span>
                </div>
            </div>

            <style>{`
                @keyframes statsGlow {
                    0% { box-shadow: 0 8px 25px rgba(0,0,0,0.5), 0 0 15px rgba(65,105,225,0.3); }
                    100% { box-shadow: 0 8px 25px rgba(0,0,0,0.5), 0 0 25px rgba(65,105,225,0.5); }
                }
                
                @keyframes scoreGlow {
                    0% { text-shadow: 0 0 10px rgba(0,191,255,0.8); }
                    100% { text-shadow: 0 0 20px rgba(0,191,255,1); }
                }
                
                @keyframes levelGlow {
                    0% { text-shadow: 0 0 10px rgba(65,105,225,0.8); }
                    100% { text-shadow: 0 0 20px rgba(65,105,225,1); }
                }
                
                @keyframes livesGlow {
                    0% { text-shadow: 0 0 10px rgba(147,112,219,0.8); }
                    100% { text-shadow: 0 0 20px rgba(147,112,219,1); }
                }
            `}</style>
        </div>
    );
};

export default GameStats; 